import { useNavigate } from "react-router";
import HeaderBar from "../../Components/HeaderBar";
import Sidebar from "../../Components/SideBar";
import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { isEmail } from "../../lib";
import LoaderSpinner from "../../Components/LoaderSpinner";

interface form {
    tipoIdentificacion  :string;
    nroIdentificacion   :string;
    razonSocial         :string;
    direccion           :string;    
    email               :string;   
    telefono            :string;            
    celular             :string; 
};

const initForm : form = {

    tipoIdentificacion  :"",
    nroIdentificacion   :"",
    razonSocial         :"",
    direccion           :"",    
    email               :"",   
    telefono            :"",            
    celular             :"" 
}

const initerr = {
    razonSocial:false, 
    direccion:false, 
    email:false, 
    telefono:false, 
    celular:false
};

const urlApiBase = process.env.REACT_APP_apiUrl;

const AfiliadoPage = () =>{

    const emp:any = useSelector((state: any) => state.emp);   

    const Body = () =>{

        let navigate = useNavigate();
        let [errs, setErrs] = useState({...initerr});
        let [dataForm, setDataForm] = useState<form>({...initForm});
        let [afiliateData, setAfiliateData] = useState<any>();
        let [datadata, setDataData] = useState<any>();     
        let [show, setShow] = useState(false);               

        const onClickBuscar = async () =>{

            setShow(true);

            const ti = dataForm.tipoIdentificacion.trim();
            const ni = dataForm.nroIdentificacion.trim();

            if ((ti === "") || (ni === "")){
                Swal.fire({
                    title: 'Busqueda de usuario',
                    text: "Seleccione un tipo de identificación y/o escriba una identificación",
                    icon: "error",
                    iconColor: "red",
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: "green"
                });

                return;
            }

            const headers = {
                headers: {
                  'Authorization': `Bearer ${emp.token}`,
                },
            };

            axios.get(`${urlApiBase}/api/Usuario/GetUsuario/${dataForm.tipoIdentificacion}/${dataForm.nroIdentificacion}`, headers)
            .then((data: any)=>{
                if (parseInt(data.data.codigo) >= 404){
                    Swal.fire({
                        title: 'Busqueda de usuario',
                        text: data.data.mensaje,
                        icon: "error",
                        iconColor: "red",
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: "green"
                    });
                }else{
                    afiliateData = data.data.jsonObject;
                    setAfiliateData({...afiliateData});
                    setDataData({...data.data});                    

                    dataForm.celular = afiliateData.Celular;
                    dataForm.direccion = afiliateData.Direccion;
                    dataForm.email = afiliateData.Email;    
                    dataForm.nroIdentificacion = afiliateData.NumeroIdentificacion;     
                    dataForm.razonSocial = afiliateData.RazonSocial;
                    dataForm.telefono = afiliateData.Telefono;    
                    dataForm.tipoIdentificacion = afiliateData.TipoIdentificacion;           
                    setDataForm({...dataForm});
                }
            })
            .catch((err)=>{
                navigate("/");
            });
            setShow(false);
        }
    
        const onChangeForm = (e: any) =>{
    
            const id = e.target.id;
            const vl = e.target.value;
    
            setDataForm({...dataForm, [id]:vl});
            setErrs({...errs, [id]: false});            
        }  
        
        const onClickLimpiar = () =>{
    
            setDataForm({...initForm});
            setErrs({...initerr});            
        }          
        
        const onClickSave = async () =>{

            let countErr = 0;
            
            // valida razon social
            if (dataForm.razonSocial.trim() === ""){
                errs.razonSocial = true;
                countErr++;
            }
            // valida dirección            
            if (dataForm.direccion.trim() === ""){
                errs.direccion = true;
                countErr++;
            }
            // valida email               
            if ((dataForm.email.trim() === "") || !isEmail(dataForm.email.trim())){
                errs.email = true;
                countErr++;
            }      
            
            setErrs({...errs});

            if (countErr === 0){

                const headers = {
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${emp.token}`,
                    },
                };

               afiliateData.Celular = dataForm.celular;
               afiliateData.Direccion = dataForm.direccion;
               afiliateData.Email = dataForm.email;    
               afiliateData.NumeroIdentificacion = dataForm.nroIdentificacion ;     
               afiliateData.RazonSocial = dataForm.razonSocial;
               afiliateData.Telefono = dataForm.telefono;    
               afiliateData.TipoIdentificacion = dataForm.tipoIdentificacion; 
               setAfiliateData({...afiliateData});

               datadata.jsonObject = afiliateData;
               setDataData({...datadata});

               // Realizar la solicitud PUT
                axios.put(`${urlApiBase}/api/Usuario/UpdateUsuario/${afiliateData.Id}`, afiliateData, headers)
                .then(response => {
                    Swal.fire({
                        title: 'Actualización de afiliado',
                        text: "Se ha actualizado al afiliado con éxito!!!",
                        icon: "success",
                        iconColor: "green",
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: "green"
                    }); 
                    setDataForm({...initForm});                   
                })
                .catch(error => {
                    console.error('Error:', error.response ? error.response.data : error.message); // Manejar errores
                    navigate("/");
                });

            }else{
                return null;
            }
        }
        
        return(
            <div>
                <div className="container text-success m-3">
                    <label className="h3">Actualización datos del empleador</label>
                </div>
                <div className="row gap-1 m-1 ">
                    <div className="col-lg-4 col-md-12">
                        <label htmlFor="inputEmail4" className="form-label">Tipo documento</label>
                        <select className="form-select form-select mb-3" id="tipoIdentificacion" value={dataForm?.tipoIdentificacion} onChange={onChangeForm}>
                            <option >Seleccione tipo documento</option>
                            <option value="CC">Cédula de ciudadanía</option>
                            <option value="NI">Nit</option>
                            <option value="TI">Tarjeta de identidad</option>
                            <option value="RC">Registro civil</option>
                            <option value="PA">Pasaporte</option>          
                            <option value="CE">Cédula de extranjería</option>   
                            <option value="PE">Permiso especial de permanencia</option>       
                            <option value="PT">Permiso por protección especial</option>                                                                                               
                        </select>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <label htmlFor="nroIdentificacion" className="form-label">Nro. identificación</label>
                        <input type="text" className="form-control" id="nroIdentificacion" value={dataForm.nroIdentificacion} onChange={onChangeForm} />
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="w-100">
                                <button type="button" onClick={onClickBuscar} className="btn btn-success w-100 d-flex justify-content-center gap-2 align-item-center">
                                    <i className="fs-6 bi-search"></i> 
                                    <span className="">Buscar</span> 
                                </button>                                
                            </div>
                        </div>
                    </div>

                    <hr className="border-5 text-success fw-bold "  />

                    <div className="col-lg-12  col-md-12 mb-3">
                        <label htmlFor="razonSocial" className="form-label">Nombre / Razón social</label>
                        <input type="text" className="form-control" id="razonSocial" placeholder="" value={dataForm.razonSocial} onChange={onChangeForm}  />
                        {errs.razonSocial && <span className="text-danger mb-2">Nombre o razón social no válida</span>}
                    </div>
                    <div className="col-lg-12 col-md-12 mb-3">
                        <label htmlFor="direccion" className="form-label">Dirección</label>
                        <input type="text" className="form-control" id="direccion" placeholder="" value={dataForm.direccion} onChange={onChangeForm}  />
                        {errs.direccion && <span className="text-danger">Debe digitar una dirección</span>}                        
                    </div>
                    <div className="col-lg-7 col-md-12 mb-3">
                        <label htmlFor="email" className="form-label">Correo electrónico</label>
                        <input type="text" className="form-control" id="email" value={dataForm.email} onChange={onChangeForm}  />
                        {errs.email && <span className="text-danger">Email no es válido</span>}                               
                    </div>
                    <div className="col-lg-2 col-md-12 mb-3">
                        <label htmlFor="telefono" className="form-label">Teléfono</label>
                        <input type="text" className="form-control" id="telefono" value={dataForm.telefono} onChange={onChangeForm} />
                        
                    </div>
                    <div className="col-lg-2 col-md-12 mb-3">
                        <label htmlFor="celular" className="form-label">Celular</label>
                        <input type="text" className="form-control" id="celular" min={0} max={10} value={dataForm.celular} onChange={onChangeForm} />
                    </div>
                    
                    <hr className="border-5 text-success fw-bold mt-3" />

                    <div className="col-lg-12 col-md-12">
                        <div className="row gap-1 ">
                            <div className="col-lg-5 col-md-12 d-flex justify-content-center">
                                <button type="button" className="btn btn-success d-flex justify-content-center align-item-center gap-1 " onClick={onClickLimpiar}>
                                    <i className="fs-6 bi-eraser"></i> 
                                    <span className="">Limpiar</span>
                                </button>                        
                            </div>
                            <div className="col-lg-5 col-md-12 d-flex justify-content-center ">
                                <button type="button" className="btn btn-success d-flex justify-content-center align-item-center gap-1 " onClick={onClickSave}>
                                    <i className="fs-6 bi-floppy2"></i> 
                                    <span className="">Guardar</span>
                                </button>                        
                            </div>  
                        </div>                        
                    </div>
                </div>  
                <LoaderSpinner
                    color="#0fc26f"
                    Show={show}
                    text="Procesando..."
                />          
            </div>            
        );
    }

    return (
        <>
            <div className=" m-3 border rounded shadow">
                <div>
                    <HeaderBar />          
                </div>
                <div className="d-flex">
                    <div className="" style={{width: "20%"}}>
                        <Sidebar />            
                    </div>
                    <div className="" style={{width: "80%"}}>
                        <Body/>            
                    </div>
                </div>
            </div>
        </>
    );
};

export default AfiliadoPage;
